export const getCompanyFromEmail = (email) => {
  if (!email) return 'Unknown';
  const domain = email.split('@')[1];
  if (!domain) return 'Unknown';
  const name = domain.split('.')[0];
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const users = [
  { id: 'U0', name: 'Admin Director', email: 'admin@jvtrack.com', company: 'CAN', userRole: 'Admin', roleScope: 'Management', position: 'Director of Operations', hourlyRate: 250, personnelNumber: '00001', costCenter: 'CC-ADM-000', overheads: { 'Aecon': 0, 'Pomerleau': 0, 'Stantec': 0, 'CAN': 100 }, managerId: null },
  { id: 'U1', name: 'Eleanor Shellstrop', email: 'eleanor@stantec.com', company: 'Stantec', userRole: 'Normal', roleScope: 'Design', position: 'Senior Architect', hourlyRate: 120, personnelNumber: '10001', costCenter: 'CC-DES-100', overheads: { 'Aecon': 0, 'Pomerleau': 0, 'Stantec': 100, 'CAN': 0 }, managerId: 'U5' },
  { id: 'U2', name: 'Chidi Anagonye', email: 'chidi@aecon.com', company: 'Aecon', userRole: 'Normal', roleScope: 'Construction', position: 'Project Engineer', hourlyRate: 95, personnelNumber: '10002', costCenter: 'CC-CON-200', overheads: { 'Aecon': 100, 'Pomerleau': 0, 'Stantec': 0, 'CAN': 0 }, managerId: 'U3' },
  { id: 'U3', name: 'Tahani Al-Jamil', email: 'tahani@can-mgmt.com', company: 'CAN', userRole: 'Management', roleScope: 'Management', position: 'Project Manager', hourlyRate: 150, personnelNumber: '10003', costCenter: 'CC-MAN-300', overheads: { 'Aecon': 0, 'Pomerleau': 0, 'Stantec': 0, 'CAN': 100 }, managerId: 'U9' },
  { id: 'U4', name: 'Jason Mendoza', email: 'jason@pomerleau.ca', company: 'Pomerleau', userRole: 'Normal', roleScope: 'Construction', position: 'Site Coordinator', hourlyRate: 80, personnelNumber: '10004', costCenter: 'CC-CON-200', overheads: { 'Aecon': 0, 'Pomerleau': 100, 'Stantec': 0, 'CAN': 0 }, managerId: 'U6' },
  { id: 'U5', name: 'Michael', email: 'michael@stantec.com', company: 'Stantec', userRole: 'Management', roleScope: 'Design', position: 'Design Director', hourlyRate: 180, personnelNumber: '10005', costCenter: 'CC-DES-100', overheads: { 'Aecon': 0, 'Pomerleau': 0, 'Stantec': 100, 'CAN': 0 }, managerId: 'U0' },
  { id: 'U6', name: 'Janet', email: 'janet@pomerleau.ca', company: 'Pomerleau', userRole: 'Management', roleScope: 'Management', position: 'Data Specialist', hourlyRate: 90, personnelNumber: '10006', costCenter: 'CC-MAN-300', overheads: { 'Aecon': 0, 'Pomerleau': 100, 'Stantec': 0, 'CAN': 0 }, managerId: 'U9' },
  { id: 'U7', name: 'Simone Garnett', email: 'simone@aecon.com', company: 'Aecon', userRole: 'Normal', roleScope: 'Construction', position: 'HSE Manager', hourlyRate: 110, personnelNumber: '10007', costCenter: 'CC-CON-200', overheads: { 'Aecon': 100, 'Pomerleau': 0, 'Stantec': 0, 'CAN': 0 }, managerId: 'U3' },
  { id: 'U8', name: 'Vicky', email: 'vicky@stantec.com', company: 'Stantec', userRole: 'Normal', roleScope: 'Design', position: 'BIM Coordinator', hourlyRate: 85, personnelNumber: '10008', costCenter: 'CC-DES-100', overheads: { 'Aecon': 0, 'Pomerleau': 0, 'Stantec': 100, 'CAN': 0 }, managerId: 'U5' },
  { id: 'U9', name: 'Shawn', email: 'shawn@can-mgmt.com', company: 'CAN', userRole: 'Management', roleScope: 'Management', position: 'Regional Director', hourlyRate: 200, personnelNumber: '10009', costCenter: 'CC-MAN-300', overheads: { 'Aecon': 0, 'Pomerleau': 0, 'Stantec': 0, 'CAN': 100 }, managerId: 'U0' },
  { id: 'U10', name: 'Derek Hostetler', email: 'derek@pomerleau.ca', company: 'Pomerleau', userRole: 'Normal', roleScope: 'Construction', position: 'Quality Inspector', hourlyRate: 75, personnelNumber: '10010', costCenter: 'CC-CON-200', overheads: { 'Aecon': 0, 'Pomerleau': 100, 'Stantec': 0, 'CAN': 0 }, managerId: 'U6' },
  { id: 'U11', name: 'Camilo Madrigal', email: 'camilo@aecon.com', company: 'Aecon', userRole: 'Normal', roleScope: 'Construction', position: 'Surveyor', hourlyRate: 70, personnelNumber: '10011', costCenter: 'CC-CON-200', overheads: { 'Aecon': 100, 'Pomerleau': 0, 'Stantec': 0, 'CAN': 0 }, managerId: 'U3' },
  { id: 'U12', name: 'Mirabel Madrigal', email: 'mirabel@stantec.com', company: 'Stantec', userRole: 'Normal', roleScope: 'Design', position: 'Junior Architect', hourlyRate: 65, personnelNumber: '10012', costCenter: 'CC-DES-100', overheads: { 'Aecon': 0, 'Pomerleau': 0, 'Stantec': 100, 'CAN': 0 }, managerId: 'U5' },
  { id: 'U13', name: 'Bruno Madrigal', email: 'bruno@can-mgmt.com', company: 'CAN', userRole: 'Normal', roleScope: 'Management', position: 'Risk Analyst', hourlyRate: 140, personnelNumber: '10013', costCenter: 'CC-MAN-300', overheads: { 'Aecon': 0, 'Pomerleau': 0, 'Stantec': 0, 'CAN': 100 }, managerId: 'U9' },
  { id: 'U14', name: 'Isabela Madrigal', email: 'isabela@pomerleau.ca', company: 'Pomerleau', userRole: 'Normal', roleScope: 'Construction', position: 'Landscape Designer', hourlyRate: 105, personnelNumber: '10014', costCenter: 'CC-CON-200', overheads: { 'Aecon': 0, 'Pomerleau': 100, 'Stantec': 0, 'CAN': 0 }, managerId: 'U6' },
  { id: 'U15', name: 'Luisa Madrigal', email: 'luisa@aecon.com', company: 'Aecon', userRole: 'Normal', roleScope: 'Construction', position: 'Foreman', hourlyRate: 90, personnelNumber: '10015', costCenter: 'CC-CON-200', overheads: { 'Aecon': 100, 'Pomerleau': 0, 'Stantec': 0, 'CAN': 0 }, managerId: 'U3' }
];

export const wbsCodes = [
  // Phase 1: Mobilization & Design (Jan 2024 - June 2024)
  { id: 'WBS-P1-Z1', code: 'MOB-101.A', description: 'Site Office Setup', scope: 'Construction', phase: 'Phase 1: Mobilization', zone: 'Zone A', bac: 150000, progress: 100 },
  { id: 'WBS-P1-Z2', code: 'MOB-101.B', description: 'Temporary Power', scope: 'Construction', phase: 'Phase 1: Mobilization', zone: 'Zone B', bac: 85000, progress: 100 },
  { id: 'WBS-P1-Z3', code: 'MOB-101.C', description: 'Water & Waste Connections', scope: 'Construction', phase: 'Phase 1: Mobilization', zone: 'Zone C', bac: 95000, progress: 100 },
  { id: 'WBS-P1-D1', code: 'DES-102.G', description: 'Civil Engineering Review', scope: 'Design', phase: 'Phase 1: Mobilization', zone: 'General', bac: 320000, progress: 100 },
  { id: 'WBS-P1-D2', code: 'DES-102.H', description: 'Structural Proofing', scope: 'Design', phase: 'Phase 1: Mobilization', zone: 'General', bac: 280000, progress: 100 },
  { id: 'WBS-P1-M1', code: 'PM-103.G', description: 'Project Charter & Planning', scope: 'Management', phase: 'Phase 1: Mobilization', zone: 'General', bac: 120000, progress: 100 },
  
  // Phase 2: Foundations & Earthworks (July 2024 - March 2025)
  { id: 'WBS-P2-Z1', code: 'FND-201.A', description: 'Concrete Piling', scope: 'Construction', phase: 'Phase 2: Foundations', zone: 'Zone A', bac: 1200000, progress: 100 },
  { id: 'WBS-P2-Z2', code: 'FND-201.B', description: 'Excavation & Shoring', scope: 'Construction', phase: 'Phase 2: Foundations', zone: 'Zone B', bac: 850000, progress: 100 },
  { id: 'WBS-P2-Z3', code: 'FND-201.C', description: 'U/G Utilities', scope: 'Construction', phase: 'Phase 2: Foundations', zone: 'Zone C', bac: 550000, progress: 100 },
  { id: 'WBS-P2-Z4', code: 'FND-201.D', description: 'Slab on Grade', scope: 'Construction', phase: 'Phase 2: Foundations', zone: 'Zone A', bac: 980000, progress: 100 },
  { id: 'WBS-P2-Q1', code: 'QA-202.G', description: 'Soil Stability Testing', scope: 'Construction', phase: 'Phase 2: Foundations', zone: 'General', bac: 45000, progress: 100 },
  
  // Phase 3: Main Structure & Envelope (April 2025 - Dec 2025)
  { id: 'WBS-P3-Z1', code: 'STR-301.A', description: 'Structural Steel', scope: 'Construction', phase: 'Phase 3: Structure', zone: 'Zone A', bac: 2500000, progress: 100 },
  { id: 'WBS-P3-Z2', code: 'STR-301.B', description: 'Concrete Decking', scope: 'Construction', phase: 'Phase 3: Structure', zone: 'Zone B', bac: 1800000, progress: 100 },
  { id: 'WBS-P3-Z3', code: 'STR-301.C', description: 'Reinforcement Steel', scope: 'Construction', phase: 'Phase 3: Structure', zone: 'Zone C', bac: 1400000, progress: 100 },
  { id: 'WBS-P3-E1', code: 'ENV-302.G', description: 'Curtain Wall Install', scope: 'Construction', phase: 'Phase 3: Structure', zone: 'General', bac: 3200000, progress: 100 },
  { id: 'WBS-P3-E2', code: 'ENV-302.R', description: 'Roofing Membrane', scope: 'Construction', phase: 'Phase 3: Structure', zone: 'General', bac: 950000, progress: 100 },
  
  // Phase 4: Fit-out & Systems (Jan 2026 - Present/March 2026)
  { id: 'WBS-P4-Z1', code: 'FIN-401.A', description: 'Partition Walls', scope: 'Construction', phase: 'Phase 4: Finishing', zone: 'Zone A', bac: 850000, progress: 85 },
  { id: 'WBS-P4-Z2', code: 'FIN-401.B', description: 'Mechanical/Electrical Fit-out', scope: 'Construction', phase: 'Phase 4: Finishing', zone: 'Zone B', bac: 4500000, progress: 45 },
  { id: 'WBS-P4-Z3', code: 'FIN-401.C', description: 'Interior Drywall', scope: 'Construction', phase: 'Phase 4: Finishing', zone: 'Zone C', bac: 1200000, progress: 30 },
  { id: 'WBS-P4-F1', code: 'FIN-402.A', description: 'Flooring Installation', scope: 'Construction', phase: 'Phase 4: Finishing', zone: 'Zone A', bac: 650000, progress: 10 },
  { id: 'WBS-P4-M1', code: 'COM-402.G', description: 'Systems Commissioning', scope: 'Management', phase: 'Phase 4: Finishing', zone: 'General', bac: 850000, progress: 15 }
];

// Helper to determine planned progress % for a date
const getPlannedProgress = (wbs, date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = d.getMonth();
    
    if (wbs.phase.includes('Phase 1')) {
        if (year < 2024) return 0;
        if (year > 2024 || (year === 2024 && month > 5)) return 100;
        return (month + 1) * (100 / 6);
    }
    if (wbs.phase.includes('Phase 2')) {
        if (year < 2024 || (year === 2024 && month < 6)) return 0;
        if (year > 2025 || (year === 2025 && month > 2)) return 100;
        const totalMonths = 9;
        const elapsed = year === 2024 ? (month - 6) : (month + 6);
        return Math.min(100, elapsed * (100 / totalMonths));
    }
    if (wbs.phase.includes('Phase 3')) {
        if (year < 2025 || (year === 2025 && month < 3)) return 0;
        if (year > 2025) return 100;
        const totalMonths = 9;
        const elapsed = month - 3;
        return Math.min(100, elapsed * (100 / totalMonths));
    }
    if (wbs.phase.includes('Phase 4')) {
        if (year < 2026) return 0;
        if (year > 2026 || month > 5) return 100;
        return (month + 1) * (100 / 6);
    }
    return 0;
};

// Helper to generate entries
const generateEntries = () => {
    const entries = [];
    let entryId = 1;
    const startDate = new Date('2024-01-01'); // Start from the beginning of Phase 1
    const today = new Date('2026-03-14');
    
    for (let d = new Date(startDate); d <= today; d.setDate(d.getDate() + 1)) {
        // Only log for weekdays
        if (d.getDay() === 0 || d.getDay() === 6) continue;

        const dateStr = d.toISOString().split('T')[0];
        const year = d.getFullYear();
        const month = d.getMonth();
        
        // Determine project phase based on date
        let phase = 'Phase 4: Finishing';
        if (year === 2024 && month <= 5) phase = 'Phase 1: Mobilization';
        else if ((year === 2024 && month > 5) || (year === 2025 && month <= 2)) phase = 'Phase 2: Foundations';
        else if (year === 2025 && month > 2) phase = 'Phase 3: Structure';

        users.forEach(user => {
            // High probability of entry for full-time look
            if (Math.random() > 0.95) return; 

            const possibleWBS = wbsCodes.filter(w => 
                w.phase === phase && (w.scope === user.roleScope || user.roleScope === 'Management')
            );
            
            if (possibleWBS.length > 0) {
                // Determine how many WBS codes this user works on today (1 or 2)
                const numCodes = Math.random() > 0.8 ? 2 : 1;
                const shuffled = [...possibleWBS].sort(() => 0.5 - Math.random());
                
                for (let i = 0; i < numCodes; i++) {
                    const wbs = shuffled[i];
                    if (!wbs) break;

                    const status = d < new Date('2026-03-01') ? 'Approved' : (Math.random() > 0.3 ? 'Approved' : 'Pending');
                    entries.push({
                        id: `T${entryId++}`,
                        userId: user.id,
                        wbsCode: wbs.code,
                        date: dateStr,
                        hours: (numCodes === 1 ? 8 : 4) + (Math.random() > 0.8 ? 2 : 0),
                        status: status
                    });
                }
            }
        });
    }
    return entries;
};

export const initialTimesheetEntries = generateEntries();

const generateSCurveData = () => {
    const data = [];
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const years = [2024, 2025, 2026];
    
    let cumPV = 0;
    let cumEV = 0;
    let cumAC = 0;

    years.forEach(year => {
        const lastMonth = year === 2026 ? 2 : 11;
        for(let m = 0; m <= lastMonth; m++) {
            const date = `${year}-${String(m+1).padStart(2, '0')}-01`;
            let monthlyPV = 0;
            let monthlyEV = 0;

            wbsCodes.forEach(wbs => {
                const plannedAtDate = getPlannedProgress(wbs, date) / 100;
                const actualProgressAtDate = Math.min(plannedAtDate * (0.95 + Math.random() * 0.1), wbs.progress / 100);
                // Adjusting PV/EV calculation for more realistic scale
                monthlyPV += (wbs.bac * (getPlannedProgress(wbs, date) / 100)) / 12; 
                monthlyEV += (wbs.bac * actualProgressAtDate) / 12;
            });

            const entriesInMonth = initialTimesheetEntries.filter(e => {
                const ed = new Date(e.date);
                return ed.getFullYear() === year && ed.getMonth() === m;
            });
            const monthlyAC = entriesInMonth.reduce((sum, e) => sum + (e.hours * 150), 0);

            cumPV += monthlyPV / 4; // Smoothing for cumulative
            cumEV += monthlyEV / 4;
            cumAC += monthlyAC;

            data.push({
                name: `${months[m]} ${String(year).slice(2)}`,
                pv: Math.round(cumPV / 1000000 * 10) / 10,
                ev: Math.round(cumEV / 1000000 * 10) / 10,
                ac: Math.round(cumAC / 1000000 * 10) / 10
            });
        }
    });
    return data;
};

export const sCurveData = generateSCurveData();

export const financialData = {
  kpis: [
    { label: 'COST PERFORMANCE (CPI)', value: '1.08', trend: '+0.04', vsBudget: '1.02', status: 'positive' },
    { label: 'SCHEDULE PERFORMANCE (SPI)', value: '0.96', trend: '-0.02', vsPY: '1.00', status: 'neutral' },
    { label: 'ESTIMATE AT COMPLETION (EAC)', value: '$22.4M', trend: '-1.8%', roa: 'BAC: $23.2M', status: 'positive' },
    { label: 'VARIANCE AT COMPLETION (VAC)', value: '+$850K', trend: '+22.4%', underBudget: 'Budget', status: 'positive' },
  ],
  geography: [
    { name: 'Zone A: North Wing', value: 4.8, color: '#3b82f6', pct: 35 },
    { name: 'Zone B: South Wing', value: 3.2, color: '#60a5fa', pct: 24 },
    { name: 'Zone C: Infrastructure', value: 3.5, color: '#93c5fd', pct: 26 },
    { name: 'Zone D: Parking & Landscape', value: 1.4, color: '#bfdbfe', pct: 10 },
    { name: 'General/Site-wide', value: 0.7, color: '#dbeafe', pct: 5 }
  ],
  marginTrend: [
    { month: 'MAR 24', margin: 18, budget: 20 },
    { month: 'JUN 24', margin: 22, budget: 24 },
    { month: 'SEP 24', margin: 28, budget: 30 },
    { month: 'DEC 24', margin: 35, budget: 38 },
    { month: 'MAR 25', margin: 32, budget: 35 },
    { month: 'JUN 25', margin: 40, budget: 42 },
    { month: 'SEP 25', margin: 45, budget: 48 },
    { month: 'DEC 25', margin: 52, budget: 55 },
    { month: 'MAR 26', margin: 58, budget: 62 }
  ]
};
